<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <div class="card-body">
            <AppAlertNote v-if="canEdit">The person's address is retrieved from their assigned building. If their
                address is blank, assign them to a building and a room number.
            </AppAlertNote>

            <PersonAddressRow :address="physicalAddress"
                              :building-list="buildingList"
                              :person-id="personId"></PersonAddressRow>
            <PersonAddressRow :address="mailingAddress"
                              :building-list="buildingList"
                              :person-id="personId"></PersonAddressRow>


        </div>
        <div class="card-footer d-print-none text-right">
            <RouterLink :to="{name:'People'}" class="btn btn-danger">Back</RouterLink>
        </div>
    </AppLoadingContainer>
</template>

<script>
    import AddressService from "../../services/AddressService";
    import AppAlertNote from "@/components/shared/AppAlertNote";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import PersonAddressRow from "@/components/people/PersonAddressRow";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            PersonAddressRow,
            AppAlertNote,
            AppLoadingContainer,
        },
        data() {
            return {
                buildingList: [],
                isLoaded: false,
                physicalAddress: {},
                mailingAddress: {}
            }
        },
        props: {
            personId: {
                type: String,
                required: true,
            }
        },
        computed: {
            /**
             * @description Indicates if this form can be edited by the person based on the given role
             * @returns {boolean}
             */
            canEdit() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.Facilities);
            }
        },
        created() {
            const vm = this;

            Promise.all([
                AddressService.getPersonAddresses(vm.personId)
                    .then(response => {
                        const addresses = response;

                        vm.physicalAddress = addresses.find(el => el.addressType === 'Physical');
                        vm.mailingAddress = addresses.find(el => el.addressType === 'Routine Mail');

                        // Note: We are adding "Missing" address types
                        if (!vm.mailingAddress)
                            vm.mailingAddress = {
                                addressType: 'Routine Mail',
                                buildingId: null,
                                suite: null,
                                roomNumber: null,
                            };

                        if (!vm.physicalAddress)
                            vm.physicalAddress = {
                                addressType: 'Physical',
                                buildingId: null,
                                suite: null,
                                roomNumber: null,
                            };

                        vm.physicalAddress.label = "Physical Address";
                        vm.mailingAddress.label = "Mailing Address"
                    }),

                AddressService.getAllBuildings()
                    .then(response => {
                        vm.buildingList = response
                    })]).catch(() => {
                vm.redirectToError();
            }).finally(() => {
                vm.isLoaded = true
            });
        }
    }
</script>
